
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Actualite from '@/extend/classes/Actualite';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeActualite' })

export default class storeActualite extends VuexModule {
  // States
  private reccords: Actualite[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get actualiteLoading (): boolean {
    return this.dataLoading;
  }
  private get actualiteRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get actualiteLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewActualite() {
    return (): Actualite => { 
      return this.getActualite(0, true);
    }
  }

  
  public get getActualite () {
    return (id: number, canCreate = false): Actualite => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Actualite can't be 0")
        return new Actualite();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Actualite();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Actualite.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromActualite(data.reccords[0] as Actualite);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listActualite (): Actualite[] {
    return this.reccords;
  }

  public get listConfigActualite (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mActualiteRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mActualiteClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mActualiteLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mActualiteLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Actualite.fromJson(reccord as Actualite));
    })
    Actualite.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mActualiteConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mActualiteCreated (obj: Actualite): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareActualite(obj)) {
          api.fromActualite(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareActualite(obj)) {
            api.fromActualite(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mActualiteUpdated (obj: Actualite): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareActualite(obj)) {
          api.fromActualite(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mActualiteDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerActualite (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.actualiteRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerActualite(this.actualiteCreated, this.actualiteUpdated, this.actualiteDeleted);
          this.mActualiteRegistered();
        } else {
          setTimeout(() => resolve(this.registerActualite(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.actualiteLoading && !this.actualiteLoaded) {
          this.mActualiteLoading(true);
          return Actualite.list(filter)
            .then((data: ListData) => {
              this.mActualiteLoaded(data);
              this.mActualiteLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredActualite (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.actualiteLoading) {
        this.mActualiteLoading(true);
        return Actualite.list(filter)
          .then((data: ListData) => {
            this.mActualiteLoaded(data);
            this.mActualiteLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createActualite (obj: Actualite): Promise<Actualite> {
    return new Promise((resolve, reject) => {
      return Actualite.fromJson(obj).createForStoreActualite()
        .then((reccords) => {
          this.mActualiteCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateActualite (obj: Actualite): Promise<Actualite> {
    return new Promise((resolve, reject) => {
      return Actualite.fromJson(obj).updateForStoreActualite()
        .then((reccords) => {
          this.mActualiteUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteActualite (obj: Actualite): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Actualite.fromJson(obj).deleteForStoreActualite()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mActualiteDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private actualiteCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mActualiteConfigUpdated(config)
    const obj = objConfig.obj as Actualite;
    this.mActualiteCreated(Actualite.fromJson(obj));
  }

  @Action
  private actualiteUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mActualiteConfigUpdated(config)
    const obj = objConfig.obj as Actualite;
    this.mActualiteUpdated(Actualite.fromJson(obj));
  }

  @Action
  private actualiteDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Actualite;
    this.mActualiteDeleted(obj.id);
  }
}
